<template>
  <div>
    <!-- {{ selected }} -->
    <v-layout>
      <v-flex sm6 class="ml-4">
        <!-- <div>
          <v-btn
            v-if="selected.length"
            round
            color="success"
            @click="bulkAccept"
          >
            Accept all
          </v-btn>
          <v-btn v-if="selected.length" round color="error" @click="bulkReject">
            Reject all
          </v-btn>
          <v-btn
            round
            color="red"
            class="ml-1 white--text"
            @click="searchResponse"
          >
            <v-icon class="mr-2">search</v-icon>
            Search in responses
          </v-btn>
          <v-btn
            v-if="status == 6"
            class="white--text"
            color="red"
            round
            @click="download"
          >
            Download Responses
          </v-btn>
          <v-btn
            v-if="status == 6 && download_project_image != null"
            class="white--text"
            color="red"
            round
            @click="downloadImage"
          >
            Download All Images
          </v-btn>
          <v-btn
            v-if="status == 6 && download_project_audio != null"
            class="white--text"
            color="red"
            round
            @click="downloadAudio"
          >
            Download All Audios
          </v-btn>
          <v-btn
            v-if="status == 6 && download_project_video != null"
            class="white--text"
            color="red"
            round
            @click="downloadVideo"
          >
            Download All Videos
          </v-btn>
        </div> -->
        <!-- <div v-if="selected.length">
          <v-btn round small color="error" @click="bulkReject">
            Reject all
          </v-btn>
        </div> -->
        <v-layout>
          <v-flex class="sm-4 mt-2">
            <v-btn
              small
              v-if="selected.length"
              color="success"
              @click="bulkAccept"
            >
              Accept all
            </v-btn>
            <v-btn
              small
              v-if="selected.length"
              color="error"
              @click="bulkReject"
            >
              Reject all
            </v-btn>
          </v-flex>
          <v-flex class="sm-4" v-if="status == 6"></v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm4 offset-sm2>
        <v-text-field
          v-model="query"
          append-icon="search"
          label="Search"
          @input="debounceSearch"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <!-- {{ selected }} -->

    <v-data-table
      :headers="headers"
      :items="responses"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      v-model="selected"
      :select-all="status == 2"
    >
      <template v-slot:items="props" v-if="total > 0">
        <td class="text-xs-center" v-if="status == 2">
          <v-checkbox
            v-model="props.selected"
            color="#f66"
            hide-details
          ></v-checkbox>
        </td>
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td
          class="text-xs-center"
          v-if="checkIfOfflineSurvey(props.item.agent_option)"
        >
          {{ props.item.respondent_id || "N/A" }}
        </td>
        <td class="text-xs-center">{{ props.item.modification_number }}</td>
        <td class="text-xs-center">{{ props.item.dasher_id }}</td>
        <td class="text-xs-center">{{ props.item.started_at }}</td>
        <td class="text-xs-center">{{ props.item.completed_at }}</td>
        <td
          class="text-xs-center"
          :style="status == 2 ? 'min-width: 120px;' : ''"
        >
          <div class="actions">
            <ProjectResponsePreview
              :openPreview="openPreview"
              :editedItem="props.item"
              :questions="questions"
              :status="status"
              :res_audio="res_audio"
              :res_image="res_image"
              :res_video="res_video"
              :res_file="res_file"
              @reset="reset"
            />
            <div v-if="status == 2" class="mx-auto">
              <v-icon
                color="success"
                @click="verifyItem(props.item)"
                title="Accept"
              >
                done
              </v-icon>
            </div>
            <div v-if="status == 2">
              <v-icon
                color="error"
                @click="rejectItem(props.item)"
                title="Reject"
              >
                close
              </v-icon>
            </div>
          </div>
        </td>
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          No Data Available
        </v-alert>
      </template>
      <template v-slot:pageText>
        Rows {{ from }} - {{ to }} of {{ total }}
      </template>
    </v-data-table>
    <v-pagination
      v-if="total > 0"
      v-model="currentPage"
      :length="lastPage"
      color="#f66"
      class="mt-3"
      @input="fetchResponses"
    ></v-pagination>

    <!-- <ProjectActionsResponseDialog
      :results="results"
      v-model="responseDialog"
      :stop="stop"
      @stopAction="stop = true"
      :total="selected.length"
    /> -->
  </div>
</template>
<script>
import api from "../../api/datadash";
// import axios from "axios";
import { mapState } from "vuex";
import { debounce } from "lodash";
import ProjectResponsePreview from "./ProjectResponsePreview";
// import ProjectActionsResponseDialog from "./ProjectActionsResponseDialog";
export default {
  components: {
    ProjectResponsePreview,
    //  ProjectActionsResponseDialog
  },
  props: ["status"],
  data() {
    return {
      openPreview: false,
      active: 0,
      loading: false,
      headers: [
        {
          text: "Task ID",
          value: "id",
          align: "center",
        },
        // { text: "Project ID", value: "project_id", align: "center" },
        {
          text: "Modification Number",
          value: "modification_number",
          align: "center",
        },
        { text: "Dasher ID", value: "dasher_id", align: "center" },
        { text: "Stat Time", value: "started_at", align: "center" },
        { text: "Completed Time", value: "completed_at", align: "center" },
        { text: "Actions", sortable: false, align: "center" },
      ],
      responses: [],
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      from: 0,
      to: 0,
      total: 0,
      currentPage: 1,
      lastPage: 1,
      query: "",
      selected: [],
      questions: [],
      stop: false,
      disabled: false,
      selectedRejectSuggestion: "",
      responseDialog: false,
      results: [],
      excelUrl: "#",
      res_audio: "",
      res_image: "",
      res_video: "",
      res_file: "",
      download_project_image: "",
      download_project_audio: "",
      download_project_video: "",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  watch: {
    pagination() {
      this.fetchResponses();
    },
    responseDialog() {
      if (this.responseDialog == false) {
        this.fetchResponses();
        this.$emit("reset");
      }
    },
    // selected: {
    //   handler: function (newValue) {
    //     this.$emit("selected", this.selected);
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.fetchResponses();
  },
  methods: {
    async reset() {
      await this.fetchResponses();
      this.$emit("reset");
    },

    async bulkAccept() {
      this.runAction(
        "accept",
        "Are you sure want to accept all these applications?"
      );
    },

    async bulkReject() {
      this.runAction(
        "reject",
        "Are you sure want to reject all these applications?"
      );
    },

    async runAction(url, message) {
      let popUpMsg = confirm(message);

      if (popUpMsg) {
        this.stop = false;
        //   this.disabled = true;
        this.responseDialog = true;
        this.results = [];
        for (let response of this.selected.sort((a, b) => a.id - b.id)) {
          if (this.stop) {
            break;
          }
          response.loading = true;
          this.results = this.results;
          this.results.unshift(response);

          // Delay 0.5 second before every request
          await new Promise((resolve) => setTimeout(resolve, 500));

          try {
            let { data } = await api.fetchData(
              this.auth.token,
              `${url}/${response.id}/${response.project_id}`
            );

            this.newResults = [...this.results];

            this.newResults[0] = {
              ...this.newResults[0],
              error: data.error,
              errorMsg: data.errorMsg,
              loading: false,
              errorStatusMsg: data.error ? "Error" : "Success",
            };

            this.results = this.newResults;
          } catch (error) {
            this.newResults = [...this.results];

            this.newResults[0] = {
              ...this.newResults[0],
              error: 1,
              errorMsg: "Something wrong happened",
              loading: false,
              errorStatusMsg: "Failed",
            };
            this.results = this.newResults;
          }
        }
        this.stop = true;
        //   this.disabled = false;
      }
    },
    // download() {
    //   window.open(this.excelUrl);
    // },
    // downloadImage() {
    //   // window.open(this.download_project_image);
    //   this.downloadFiles(
    //     "project-" + this.$route.params.id + "-image-files.zip",
    //     this.download_project_image
    //   );
    // },

    // downloadAudio() {
    //   this.downloadFiles(
    //     "project-" + this.$route.params.id + "-audio-files.zip",
    //     this.download_project_audio
    //   );
    // },
    // downloadVideo() {
    //   this.downloadFiles(
    //     "project-" + this.$route.params.id + "-video-files.zip",
    //     this.download_project_video
    //   );
    // },
    // downloadFiles(fileName, downloadUrl) {
    //   axios({
    //     url: downloadUrl,
    //     method: "GET",
    //     responseType: "blob",
    //     Authorization: `Bearer ${this.token}`,
    //   }).then((response) => {
    //     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //     var fileLink = document.createElement("a");
    //     fileLink.href = fileURL;
    //     fileLink.setAttribute("download", fileName);
    //     document.body.appendChild(fileLink);

    //     fileLink.click();
    //   });
    // },
    async fetchResponses() {
      this.loading = true;
      try {
        const { data } = await api.fetchData(
          this.auth.token,
          `task-status?search=${this.query}&page=${this.currentPage}&per_page=${this.pagination.rowsPerPage}&taskTableName=${this.$route.params.id}&taskStatusId=${this.status}`
        );
        this.responses = data.data[`dataStatus${this.status}`].data;
        this.from = data.data[`dataStatus${this.status}`].from || 0;
        this.to = data.data[`dataStatus${this.status}`].to || 0;
        this.total = data.data[`dataStatus${this.status}`].total;
        this.currentPage = data.data[`dataStatus${this.status}`].current_page;
        this.lastPage = data.data[`dataStatus${this.status}`].last_page;
        this.questions = data.data.questions;
        this.excelUrl = data.data.excelUrl;
        this.res_audio = data.data.res_audio;
        this.res_image = data.data.res_image;
        this.res_video = data.data.res_video;
        this.res_file = data.data.res_file;
        this.download_project_image = data.data.download_project_image;
        this.download_project_audio = data.data.download_project_audio;
        this.download_project_video = data.data.download_project_video;
        this.download_project_file = data.data.download_project_file;

        this.setHeader(data.data.agent_option);
        this.$emit("downloads", {
          excelUrl: this.excelUrl,
          download_project_image: this.download_project_image,
          download_project_audio: this.download_project_audio,
          download_project_video: this.download_project_video,
          download_project_file: this.download_project_file,
        });
      } catch (e) {
        // console.log(e);
      }
      this.loading = false;
    },
    setHeader(agent_option) {
      if (this.checkIfOfflineSurvey(agent_option)) {
        if (!this.checkIfContainsRespondentID()) {
          this.headers.splice(1, 0, {
            text: "Respondent ID",
            value: "respondent_id",
            align: "center",
          });
        }
      }
      return this.headers;
    },
    checkIfOfflineSurvey(agent_option) {
      return agent_option == 2;
    },
    checkIfContainsRespondentID() {
      return this.headers.some((header) => header.text === "Respondent ID");
    },
    changePerPage() {
      this.page = 1;
      this.fetchResponses();
    },
    debounceSearch: debounce(function () {
      // Debounce the search method with a delay of 500ms
      // Perform the search with the current search text
      this.currentPage = 1;
      this.fetchResponses();
    }, 500),
    openPreviewDialog() {
      this.openPreview = true;
    },
    searchResponse() {
      this.$router.push(`/${this.$route.params.id}/search-in-response`);
    },
    async verifyItem(item) {
      var popUpMsg = confirm("Are you sure want to accept this application?");
      if (popUpMsg) {
        try {
          await api.fetchData(
            this.auth.token,
            `accept/${item.id}/${item.project_id}`
          );

          await this.fetchResponses();
          this.$emit("reset");
        } catch (e) {
          //
        }
      }
    },
    async rejectItem(item) {
      var popUpMsg = confirm("Are you sure want to reject this application?");
      if (popUpMsg) {
        try {
          await api.fetchData(
            this.auth.token,
            `reject/${item.id}/${item.project_id}`
          );

          await this.fetchResponses();
          this.$emit("reset");
        } catch (e) {
          //
        }
      }
    },

    // async bulkAccept() {
    //   this.runAction(
    //     "accept",
    //     "Are you sure want to accept all these applications?"
    //   );
    // },

    // async bulkReject() {
    //   this.runAction(
    //     "reject",
    //     "Are you sure want to reject all these applications?"
    //   );
    // },

    // async runAction(url, message) {
    //   let popUpMsg = confirm(message);

    //   if (popUpMsg) {
    //     this.stop = false;
    //     this.disabled = true;
    //     this.responseDialog = true;
    //     this.results = [];
    //     for (let response of this.selected.sort((a, b) => a.id - b.id)) {
    //       if (this.stop) {
    //         break;
    //       }
    //       response.loading = true;
    //       this.results = this.results;
    //       this.results.unshift(response);

    //       // Delay 0.5 second before every request
    //       await new Promise((resolve) => setTimeout(resolve, 500));

    //       try {
    //         let { data } = await api.fetchData(
    //           this.auth.token,
    //           `${url}/${response.id}/${response.project_id}`
    //         );

    //         this.newResults = [...this.results];

    //         this.newResults[0] = {
    //           ...this.newResults[0],
    //           error: data.error,
    //           errorMsg: data.errorMsg,
    //           loading: false,
    //           errorStatusMsg: data.error ? "Error" : "Success",
    //         };

    //         this.results = this.newResults;
    //       } catch (error) {
    //         this.newResults = [...this.results];

    //         this.newResults[0] = {
    //           ...this.newResults[0],
    //           error: 1,
    //           errorMsg: "Something wrong happened",
    //           loading: false,
    //           errorStatusMsg: "Failed",
    //         };
    //         this.results = this.newResults;
    //       }
    //     }
    //     this.stop = true;
    //     this.disabled = false;
    //   }
    // },
  },
};
</script>
<style scoped>
.actions {
  display: none;
}
tr:hover td > .actions {
  display: flex;
}
</style>
